import { REST_OF_AMERICAS_GEOS } from './restOfAmericasGeos';

const US_SUPPORTED_LOCALES = ['en', 'fr', 'pt', 'es'];

const US_SUPPORTED_GEOS = ['USA', 'CAN', 'BRA', ...REST_OF_AMERICAS_GEOS];

export { US_SUPPORTED_LOCALES, US_SUPPORTED_GEOS };
